var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("page-step-layout", {
    scopedSlots: _vm._u(
      [
        {
          key: "title",
          fn: function () {
            return [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t(
                      "application-standalone.pages.submit.reviewAndSubmit"
                    )
                  ) +
                  "\n  "
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "content",
          fn: function () {
            return [
              _c(
                "section-title",
                {
                  staticClass: "mt-2 mb-4",
                  attrs: { "title-type": "subtitle" },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.pages.submit.information"
                        )
                      ) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("page-toggler-layout", {
                scopedSlots: _vm._u([
                  {
                    key: "summary",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          [
                            _c("goal-property-section", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isPageVisible(
                                    _vm.APPLICATION_STEPS.GOALS
                                  ),
                                  expression:
                                    "isPageVisible(APPLICATION_STEPS.GOALS)",
                                },
                              ],
                              attrs: {
                                "has-missing-information":
                                  _vm.hasMissingInformation(
                                    _vm.APPLICATION_STEPS.GOALS
                                  ),
                              },
                              on: {
                                edit: function ($event) {
                                  return _vm.$emit(
                                    "navigate-edit",
                                    _vm.APPLICATION_STEPS.GOALS
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm.isPageVisible(_vm.APPLICATION_STEPS.APPLICANTS)
                              ? _c("applicants-section", {
                                  staticClass: "card",
                                  attrs: {
                                    "has-missing-information":
                                      _vm.hasMissingInformation(
                                        _vm.APPLICATION_STEPS.APPLICANTS
                                      ),
                                  },
                                  on: {
                                    edit: function ($event) {
                                      return _vm.$emit(
                                        "navigate-edit",
                                        _vm.APPLICATION_STEPS.APPLICANTS
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.applicationHasIdentifications &&
                            _vm.isPageVisible(
                              _vm.APPLICATION_STEPS.IDENTIFICATIONS
                            )
                              ? _c("identifications-section", {
                                  staticClass: "card",
                                  attrs: {
                                    "has-missing-information":
                                      _vm.hasMissingInformation(
                                        _vm.APPLICATION_STEPS.IDENTIFICATIONS
                                      ),
                                  },
                                  on: {
                                    edit: function ($event) {
                                      return _vm.$emit(
                                        "navigate-edit",
                                        _vm.APPLICATION_STEPS.IDENTIFICATIONS
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isPageVisible(
                              _vm.APPLICATION_STEPS.INCOME_HISTORY
                            )
                              ? _c("income-history-section", {
                                  staticClass: "card",
                                  attrs: {
                                    "has-missing-information":
                                      _vm.hasMissingInformation(
                                        _vm.APPLICATION_STEPS.INCOME_HISTORY
                                      ),
                                  },
                                  on: {
                                    edit: function ($event) {
                                      return _vm.$emit(
                                        "navigate-edit",
                                        _vm.APPLICATION_STEPS.INCOME_HISTORY
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isPageVisible(_vm.APPLICATION_STEPS.ASSETS)
                              ? _c("assets-section", {
                                  staticClass: "card",
                                  attrs: {
                                    "has-missing-information":
                                      _vm.hasMissingInformation(
                                        _vm.APPLICATION_STEPS.ASSETS
                                      ),
                                  },
                                  on: {
                                    edit: function ($event) {
                                      return _vm.$emit(
                                        "navigate-edit",
                                        _vm.APPLICATION_STEPS.ASSETS
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.applicationHasLiabilities &&
                            _vm.isPageVisible(_vm.APPLICATION_STEPS.LIABILITIES)
                              ? _c("liabilities-section", {
                                  staticClass: "card",
                                  attrs: {
                                    "has-missing-information":
                                      _vm.hasMissingInformation(
                                        _vm.APPLICATION_STEPS.LIABILITIES
                                      ),
                                  },
                                  on: {
                                    edit: function ($event) {
                                      return _vm.$emit(
                                        "navigate-edit",
                                        _vm.APPLICATION_STEPS.LIABILITIES
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isPageVisible(
                              _vm.APPLICATION_STEPS.OTHER_PROPERTIES
                            )
                              ? _c("other-properties-section", {
                                  staticClass: "card",
                                  attrs: {
                                    "has-missing-information":
                                      _vm.hasMissingInformation(
                                        _vm.APPLICATION_STEPS.OTHER_PROPERTIES
                                      ),
                                  },
                                  on: {
                                    edit: function ($event) {
                                      return _vm.$emit(
                                        "navigate-edit",
                                        _vm.APPLICATION_STEPS.OTHER_PROPERTIES
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.userCanSubmit || _vm.APPLICATION_IS_LOCKED
                              ? _c(
                                  "b-container",
                                  { staticClass: "align-self-center" },
                                  [
                                    _c(
                                      "b-row",
                                      [
                                        _c("b-col", { attrs: { cols: "12" } }, [
                                          _c(
                                            "p",
                                            { staticClass: "text-center bold" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.applicationMessage
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          !(
                                            _vm.EMAIL_VERIFIED ||
                                            _vm.IS_FILL_OUT
                                          )
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "text-center bold",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "application-standalone.pages.submit.verifyEmailAfterSubmitApplication"
                                                        )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "span",
                                  [
                                    !_vm.IS_FILL_OUT
                                      ? _c("additional-information-section")
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.showDisclaimersSection
                                      ? _c("disclaimers-section", {
                                          on: {
                                            "is-valid": function ($event) {
                                              _vm.isConsentsValid = $event
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "navigation",
          fn: function () {
            return [
              _vm._t("navigation-toolbar", null, null, {
                handleNavigateNext: _vm.handleNavigateNext(),
                handleNavigateBack: _vm.handleNavigateBack(),
                displayNext: _vm.userCanSubmit,
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }